import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  sharedsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'revisionService',
    '$filter',
    '$state',
    '$controller',
    'authService',
    'EQuickAccessItems',
    'EDocumentStatus',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      revisionService,
      $filter,
      $state,
      $controller,
      authService,
      EQuickAccessItems,
      EDocumentStatus
    ) {
      'use strict';

      function itemsFilter(item) {
        return item.idStatus !== EDocumentStatus.TRASH_CAN;
      }

      function goToPage(page) {
        $state.go('home.shareds', { page: page });
      }

      function loadDocuments() {
        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          $rootScope.currentDocument = null;
          $scope.count = 0;

          $scope.description = 'LOADING DOCUMENTS';
          $scope.documents(null);

          $scope.loading = true;

          var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = false;

          revisionService.cancelLoadRevisions();
          $rootScope.$broadcast(
            'loadFolder',
            EQuickAccessItems.SHAREDDOCUMENTS
          );

          revisionService.loadRevisionsShareds($scope.currentPage, 0).then(
            (data) => {
              if (data.length === 0) {
                $scope.loading = false;
                return;
              }
              $scope.pageSize = data.length;
              $scope.limite = data.length;
              $scope.count = data.length;

              $scope.totalItem = $scope.count;

              if ($scope.totalItem > $scope.limite) {
                $scope.limiteValor = $scope.limite;
                $scope.botaoAtivo = true;
              } else {
                $scope.limiteValor = $scope.totalItem;
                $scope.botaoAtivo = false;
              }

              $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

              $scope.loading = false;
              if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                $scope.goToPage($scope.pageCount);
              } else {
                authService.getUserAsync().then(user => {
                  user.userPreferences.IdLastFolder = EQuickAccessItems.SHAREDDOCUMENTS;
                });

                $scope.documents(data);
                $scope.groups = [];

                var sharedByMe = [];
                var sharedWithMe = [];

                $scope.documents().forEach((doc) => {
                  if (doc.sharedBy && doc.sharedBy.Id === $rootScope.user.id) {
                    sharedByMe.push(doc);
                  } else {
                    sharedWithMe.push(doc);
                  }
                });

                $scope.groups = [
                  {
                    id: 'sharedWithMe',
                    title: $filter('translate')('SHARED WITH ME'),
                    items: sharedWithMe,
                  },
                  {
                    id: 'sharedByMe',
                    title: $filter('translate')('SHARED BY ME'),
                    items: sharedByMe,
                  },
                ];

                $scope.description = $scope.getDescription(
                  $scope.currentPage,
                  $scope.pageSize,
                  $scope.count,
                  $scope.count
                );

                if (authService.authentication.email !== 'autologin') {
                  var date = $scope.columns.filter(function (c) {
                    return c.id === 'date';
                  })[0];
                  date.sorted = 'asc';
                  $scope.sortColumn(date);
                } else {
                  var title = $scope.columns.filter(function (c) {
                    return c.id === 'title';
                  })[0];
                  title.sorted = '';
                  $scope.sortColumn(title);
                }
              }
            },
            function (data) {
              if (
                data.status_code === 500 &&
                $scope.selectedTreeItem.Name === 'CHECKOUTS'
              ) {
                $scope.documents([]);
                return;
              }
              swal.fire(data.error, data.error_description);
            }
          );
        }
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.title = $filter('translate')('SHARED DOCS');
          $scope.description = '';
          $scope.noDocuments = $filter('translate')('NO SHAREDS');
          $scope.noDocumentsMessage = $filter('translate')('NO SHAREDS MSG');

          if (!$state.params.page) {
            $state.go('home.shareds', { page: 1 });
          }

          $scope.currentPage = $state.params.page
            ? parseInt($state.params.page)
            : 1;

          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.columns = [];
          $scope.pageCount = 1;
          $scope.canView = false;
          $scope.loading = true;
          $scope.count = 0;

          $scope.columns = [
            {
              id: 'icon',
              width: '50',
              header: $filter('translate')('COLUMN.ICON'),
              expression: 'getIcon()',
              style: {
                padding: '10px 10px 10px 26px',
                'text-overflow': 'clip',
                'max-width': '50px',
              },
              hideHeader: true,
              visible: true,
              disabled: false,
              dataPriority: 1,
            },
            {
              id: 'status',
              width: '30',
              header: $filter('translate')('COLUMN.STATUSICON'),
              expression: 'getStatusIcon()',
              style: {
                padding: '10px',
                'text-overflow': 'clip',
                'max-width': '30px',
              },
              dataPriority: 1,
              hideHeader: true,
              visible: true,
              disabled: false,
            },
            {
              id: 'code',
              header: $filter('translate')('COLUMN.CODE'),
              style: {
                'min-width': '75px',
              },
              expression: 'code',
              sortExpression: 'code',
              mobileShow: false,
              dataPriority: 3,
              visible: false,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'title',
              width: $scope.isAutologin() ? '35%' : '40%',
              header: $filter('translate')('COLUMN.TITLE'),
              expression: 'formatedTitle()',
              style: {
                'min-width': '150px',
              },
              sortExpression: 'title',
              tooltip: 'tooltipTitle()',
              dataPriority: 1,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'description',
              header: $filter('translate')('COLUMN.DESCRIPTION'),
              expression: 'formatedDescription()',
              style: {
                'min-width': '150px',
                'max-width': '600px',
              },
              sortExpression: 'description',
              visible: false,
              dataPriority: $scope.isAutologin() ? 1 : 7,
              disabled: false,
              mobileShow: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'rev',
              width: '65',
              header: $filter('translate')('COLUMN.REVNUMBER'),
              style: {
                'min-width': '65px',
              },
              expression: 'revisionNumber',
              visible: true,
              disabled: false,
              dataPriority: 3,
              mobileShow: false,
              sortable: true,
              type: 'number',
            },
            {
              id: 'author',
              header: $filter('translate')('COLUMN.AUTHOR'),
              expression: 'author.Name',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'folder',
              header: $filter('translate')('COLUMN.FOLDER'),
              expression: 'goToFolder()',
              width: '70',
              sortExpression: 'folder.Name',
              style: {
                'text-align': 'left',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 3,
              sortable: true,
              disabled: true,
              type: 'text',
            },
            {
              id: 'document type',
              header: $filter('translate')('COLUMN.DOCTYPE'),
              expression: 'formatedDocumentType()',
              style: {
                'min-width': '130px',
              },
              dataPriority: 6,
              mobileShow: false,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'date',
              header: $filter('translate')('COLUMN.DATE'),
              expression: 'formatedDate()',
              sortExpression: 'date',
              style: {
                'min-width': '85px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 5,
              disabled: false,
              sortable: true,
              type: 'date',
            },
            {
              id: 'documentDate',
              header: $filter('translate')('COLUMN.CREATION_DATE'),
              expression: 'formatedCreationDate()',
              sortExpression: 'documentDate',
              style: {
                'min-width': '85px',
              },
              mobileShow: false,
              visible: false,
              dataPriority: 5,
              disabled: false,
              sortable: true,
              type: 'date',
            },
            {
              id: 'sharedBy',
              header: 'Compartilhado por',
              expression: 'sharedBy.Name',
              style: {
                'min-width': '75px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
          ];

          $scope.itemsFilter = logWrapper(
            itemsFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
